import { App } from 'vue';
import anchorFilter from '@/project/filters/anchor.filter';

export default function config(app: App): void {
    app.use(anchorFilter);
}
